<template>
  <div class="bill-container">

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <span class="breadcrumb-item" @click="goToProfile">个人中心</span>
      <span class="breadcrumb-separator"> > </span>
      <span class="breadcrumb-item" @click="goToWallet">钱包</span>
      <span class="breadcrumb-separator"> > </span>
      <span class="breadcrumb-item active">账单</span>
    </div>

    <div class="con-box">
      <!-- 标签页 -->
      <div class="bill-tabs">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'recharge' }"
          @click="activeTab = 'recharge'"
        >
          充值记录
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'consume' }"
          @click="activeTab = 'consume'"
        >
          消费记录
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'income' }"
          @click="activeTab = 'income'"
        >
          收入记录
        </div>
      </div>

      <!-- 记录列表 -->
      <div class="records-list">
        <div v-loading="loading" class="record-items">
          <div v-if="records.length === 0 && !loading" class="empty-state">
            <div class="empty-text">暂无记录</div>
          </div>
          <div v-for="record in records" :key="record.id" class="record-item">
            <div class="record-info">
              <div class="record-type">{{ record.type_text }}</div>
              <div class="record-time">{{ record.create_time }}</div>
            </div>
            <div
              class="record-amount"
              :class="record.money_color === 'red' ? 'negative' : 'positive'"
            >
              {{ record.money_display }}
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div v-if="pagination.total > 0" class="pagination-wrapper">
          <el-pagination
            :current-page="pagination.page"
            :page-size="pagination.limit"
            :total="pagination.total"
            layout="prev, pager, next"
            :hide-on-single-page="true"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMoneyLog } from '@/api/user'

export default {
  name: 'Bill',
  data() {
    return {
      activeTab: 'recharge',
      loading: false,
      records: [],
      stats: {
        total_recharge: 0,
        total_consumption: 0,
        total_income: 0
      },
      currentBalance: '0.00',
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  watch: {
    activeTab() {
      this.pagination.page = 1 // 切换标签页时重置到第一页
      this.fetchRecords()
    }
  },
  async mounted() {
    await this.fetchRecords()
  },
  methods: {
    async fetchRecords() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit
        }

        // 根据当前标签页设置参数
        if (this.activeTab === 'recharge') {
          params.type = 'recharge'
        } else if (this.activeTab === 'consume') {
          params.type = 'consumption'
        } else if (this.activeTab === 'income') {
          params.type = 'income'
        }

        const response = await getMoneyLog(params)
        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.records = data.list || []
          this.stats = data.stats || {}
          this.currentBalance = data.current_balance || '0.00'
          this.pagination.total = data.total || 0
        } else {
          this.$message.error(response?.msg || '获取账单记录失败')
        }
      } catch (error) {
        console.error('获取账单记录失败:', error)
        this.$message.error('获取账单记录失败，请重试')
      } finally {
        this.loading = false
      }
    },
    goToProfile() {
      this.$router.push('/profile')
    },
    goToWallet() {
      this.$router.push('/profile')
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchRecords()
    }
  }
}
</script>

<style scoped>
.bill-container {
  min-height: 100vh;
  background: #F5F5F5;
  padding: 20px;
}

.con-box {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 面包屑导航 */
.breadcrumb {
	max-width: 1200px;
  margin:0 auto 24px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}

.breadcrumb-item {
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
}

.breadcrumb-item:hover {
  color: #1E80FF;
}

.breadcrumb-item.active {
  color: #303133;
  cursor: default;
}

.breadcrumb-separator {
  color: #C0C4CC;
  margin: 0 8px;
}

/* 标签页 */
.bill-tabs {
  display: flex;
  border-bottom: 1px solid #E4E7ED;
  margin-bottom: 24px;
}

.tab-item {
  padding: 12px 24px;
  cursor: pointer;
  color: #606266;
  font-size: 16px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.tab-item:hover {
  color: #1E80FF;
}

.tab-item.active {
  color: #1E80FF;
  border-bottom-color: #1E80FF;
  font-weight: 600;
}

/* 记录列表 */
.records-list {
  min-height: 400px;
}

.record-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #F0F0F0;
}

.record-item:last-child {
  border-bottom: none;
}

.record-info {
  display: flex;
  flex-direction: column;
}

.record-type {
  font-size: 16px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 4px;
}

.record-time {
  font-size: 14px;
  color: #909399;
}

.record-amount {
  font-size: 18px;
  font-weight: 600;
}

.record-amount.positive {
  color: #67C23A;
}

.record-amount.negative {
  color: #F56C6C;
}

/* 空状态 */
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.empty-text {
  color: #909399;
  font-size: 16px;
}

/* 分页样式 */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #E4E7ED;
}
</style>
